/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography } from '@coursera/cds-core';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import useIsMobile from 'bundles/unified-common/hooks/useIsMobile';

export type SyllabusItemTitleElement = React.ReactElement<Props, typeof SyllabusItemTitle>;

type Props = {
  title: string;
  slug?: string;
  link?: string;
  linkA11yLabel?: string;
  headingLevel?: 'h2';
  disableLink?: boolean;
};

const styles = {
  link: css`
    color: var(--cds-color-grey-975);

    /* doubling the current class to override CDS's blue color applied to visited links */
    &&:visited {
      color: var(--cds-color-grey-975);
    }

    &&:hover {
      color: var(--cds-color-interactive-primary);
      text-decoration: underline;
    }
  `,
  title: css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
};

const SyllabusItemTitle = ({ title, link, linkA11yLabel, disableLink, slug, headingLevel }: Props) => {
  const isMobile = useIsMobile();
  return (
    <Typography variant="h2semibold" component={headingLevel ?? 'h3'} css={!isMobile && styles.title}>
      {link && !disableLink ? (
        <Link
          href={link}
          css={styles.link}
          aria-label={linkA11yLabel}
          component={TrackedLink2}
          trackingName="sdp_course_list_link"
          data-e2e="sdp-course-list-link"
          data={{
            courseName: title,
            s12nSlug: slug,
          }}
        >
          {title}
        </Link>
      ) : (
        title
      )}
    </Typography>
  );
};

export default SyllabusItemTitle;
